import { getAnalytics } from "../../services/api";
import * as types from "../types";

const analyticsRequest = () => ({
  type: types.ANALYTICS_REQUEST,
});

const analyticsSuccess = (data) => ({
  type: types.ANALYTICS_SUCCESS,
  payload: data,
});

const analyticsFailure = (error) => ({
  type: types.ANALYTICS_FAILURE,
  payload: error,
});

export const getAnalyticsAction = (queryParams) => {
  return async (dispatch) => {
    dispatch(analyticsRequest());
    try {
      const response = await getAnalytics(queryParams);
      dispatch(analyticsSuccess(response.data));
    } catch (error) {
      dispatch(analyticsFailure(error.message));
    }
  };
};
